import { Entity, Field } from "typegraph";
import User from "panels/organizations/admin/entities/User";

@Entity({one: "organization", many: "organizations"})
export default class OrganizationFlaggedUsers {

	@Field()
	public id: string;

	@Field()
	public name: string;

	// Until we get a query from the DB, this is a temp list
	@Field({entity: User})
	public userList: User[];

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/discussion/entities/OrganizationFlaggedUsers.ts